import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['changeReasonLane'],
});

export const changeReasonLaneApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findStatusChangeByCallingNo: builder.query({
      query: (data) => `change_reason_and_lane/?calling_no=${data.calling_no}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'changeReasonLane', id: result.id }]
          : ['changeReasonLane'];
      },
    }),

    findReasonMasterChangeReasonLaneById: builder.query({
      query: (id) => `reasons/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'changeReasonLane', id: result.id }]
          : ['changeReasonLane'];
      },
    }),
    findChangeReasonLaneGroupReasonByCode: builder.query({
      query: (payload) => {
        let url = `reasons/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['changeReasonLane'],
    }),

    findChangeReasonLaneAllReasonMasters: builder.query({
      query: () => `reasons/`,
      providesTags: ['changeReasonLane'],
    }),

    updateChangeReasonLaneByReason: builder.mutation({
      query: (data) => {
        let modeReason = null;
        if (data.mode === 'Receive Job') {
          modeReason = 'receive_job';
        } else if (data.mode === 'Yard Out') {
          modeReason = 'yard_out';
        } else if (data.mode === 'Arrival') {
          modeReason = 'arrival';
        }
        let url = `status_change/reason/${data.receive_job_and_yard_out_id}/?mode=${modeReason}`;
        let postData = {
          reason_id: data.reason_id,
          reason_description: data.reason_description,
        };
        return { url: url, method: 'PUT', body: postData };
      },
      invalidatesTags: ['Reason'],
    }),

    updateChangeReasonLaneArrivalRealtimeTracking: builder.mutation({
      query: (data) => {
        let url = `realtime_trackings/reason/${data.id}/`;
        let postData = {
          reason_id: data.reason_id,
          reason_description: data.reason_description,
          reason_version: data.reason_version,
        };
        return { url: url, method: 'PUT', body: postData };
      },
      invalidatesTags: ['Reason'],
    }),
    updateChangeReasonLaneArrivalShuttleIn: builder.mutation({
      query: (body) => ({
        url: `shuttle_in/${body.id}/`,
        method: 'PATCH',
        body: body,
      }),
    }),
    updateChangeReasonLaneArrivalLane: builder.mutation({
      query: (body) => ({
        url: `shuttle_in/${body.id}/`,
        method: 'PATCH',
        body: body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindChangeReasonLaneAllReasonMastersQuery,
  useUpdateChangeReasonLaneByReasonMutation,
} = changeReasonLaneApi;
